import { FC, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { loadDatadogRumScript } from '../services/datadogRumService'

const DatadogRum: FC = (): React.ReactElement => {
  useEffect(() => {
    loadDatadogRumScript()
  }, [])

  return <Outlet />
}

export default DatadogRum
